export default __webpack_public_path__ + "static/media/baked_potato.8e6d5690.png";